<template>
  <div>
    <breadcrumb-component
      :moduleTitle="'Support'"
      :mainTitle="'Chat'"
      :subTitle="'Chat'"
    />
    <div class="row">
      <div class="col-md-12">
        <div class="card card_full_window vc_account_page">
          <div class="card_body chat_box_wrap">
            <div class="common_tab_list">
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link active"
                    id="Account-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#Account-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="Account-tab-pane"
                    aria-selected="true"
                  >
                    Live Chat
                  </button>
                </li>
                <!--                <li class="nav-item" role="presentation">
                  <button class="nav-link" id="Inquiry-tab" data-bs-toggle="tab" data-bs-target="#Inquiry-tab-pane" type="button" role="tab" aria-controls="Inquiry-tab-pane" aria-selected="false">Ticket</button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link" id="Service-tab" data-bs-toggle="tab" data-bs-target="#Service-tab-pane" type="button" role="tab" aria-controls="Service-tab-pane" aria-selected="false">Closed</button>
                </li>-->
              </ul>
            </div>
            <div class="chat_box">
              <div class="chat_box_left">
                <div class="user_list">
                  <!-- <i class="lni lni-checkmark"></i> -->
                  <ul>
                    <li
                      v-for="chat in chats"
                      :key="'chat_list' + chat.session_id"
                    >
                      <div
                        class="user_list_inner"
                        role="button"
                        :class="{ active: chat.id === selectedChat?.id }"
                        @click="selectedChat = chat"
                      >
                        <div class="img_wrap">
                          <div class="img">
                            <img src="/images/no-image.png" alt="" />
                          </div>
                        </div>
                        <div class="text">
                          <div class="time">
                            {{ chat?.lastMessage?.created_at }}
                          </div>
                          <h3 style="text-transform: capitalize">Vlan24</h3>
                          <div class="chat_text">
                            <p style="opacity: 0.5">
                              {{ chat?.lastMessage?.message }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="chat_box_right">
                <div class="user_list_inner">
                  <div class="user_list_inner_content d_flex_btwn width_full">
                    <div class="d_flex_start">
                      <div class="img_wrap">
                        <div class="img">
                          <img src="/images/logo-new.png" alt="" />
                        </div>
                      </div>
                      <div class="text">
                        <h3 class="font_16p">Vlan24</h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="left-nav-bottom-wrap" id="nav_bottom_wrap">
                  <div class="right_chat_box" id="scrollableDiv">
                    <div class="chat_box_inner" ref="scrollableDiv">
                      <ul>
                        <template
                          v-for="(message, i) in messages"
                          :key="'key_' + i"
                        >
                          <li :class="{ left: message.type === 'admin' }">
                            <div class="chat_box_inline">
                              <div class="right_arrow">
                                <div class="img">
                                  <svg
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      clip-rule="evenodd"
                                      d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Zm3-14a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm1.368 10c.342 0 .632-.259.632-.6 0-2.982-2.239-5.4-5-5.4s-5 2.418-5 5.4c0 .341.29.6.632.6h8.736Z"
                                      fill-rule="evenodd"
                                      fill="currentColor"
                                    ></path>
                                  </svg>
                                </div>
                              </div>
                              <div class="main_chat_text">
                                <div class="file" v-if="message.link">
                                  <template v-if="getFileExtension(message.link) === 'pdf'">
                                    <embed :src="message.link" width="150">
                                    <div><a :href="message.link" target="_blank">Open PDF</a></div>
                                  </template>
                                  <img
                                      v-else
                                    @load="scrollDown"
                                    :src="message.link"
                                    alt=""
                                    class="max-width-200"
                                  />
                                </div>
                                <span class="">
                                  {{ message.message }}
                                </span>
                                <div v-if="message.id" class="time">
                                  {{ message.created_at }}
                                </div>
                                <div
                                  v-if="message.type === 'customer'"
                                  class="action_list"
                                  role="button"
                                >
                                  <span @click="removeMessage(i, message)"
                                    ><i class="fas fa-trash"></i
                                  ></span>
                                  <span
                                    class="float-right"
                                    :class="[
                                      { 'checked text-success': message.read },
                                      { opacity_5: !message.read },
                                    ]"
                                    ><i class="fas fa-check"></i
                                  ></span>
                                </div>
                              </div>
                            </div>
                          </li>
                        </template>
                      </ul>

                      <div
                        v-if="selectedChat?.status === 'open'"
                        class="chat_input_box"
                      >
                        <span class="attatch_file_btn" @click="openFileModal">
                          <i class="fas fa-paperclip"></i>
                        </span>
                        <input
                          type="file"
                          ref="fileInput"
                          accept="image/*,application/pdf"
                          style="display: none"
                          @change="onFileChange($event)"
                        />
                        <input
                          class="message_input"
                          type="text"
                          v-model="form.message"
                          @keyup.enter="sendMessage('customer')"
                          @paste="handlePaste"
                          placeholder="Type your message..."
                        />

                        <button
                          class="cursor_pointer"
                          @click.prevent="sendMessage('customer')"
                        >
                          <svg
                            width="35px"
                            height="35px"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              <g clip-path="url(#clip0_15_829)">
                                <rect
                                  width="24"
                                  height="24"
                                  fill="white"
                                ></rect>
                                <path
                                  d="M19.364 5.05026L3.10051 8.58579L10.8787 13.5355M19.364 5.05026L15.8284 21.3137L10.8787 13.5355M19.364 5.05026L10.8787 13.5355"
                                  stroke="#000000"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></path>
                              </g>
                              <defs>
                                <clipPath id="clip0_15_829">
                                  <rect
                                    width="24"
                                    height="24"
                                    fill="white"
                                  ></rect>
                                </clipPath>
                              </defs>
                            </g>
                          </svg>
                        </button>
                      </div>
                      <div class="px-3 mb-3">
                        <div class="file_upload" v-if="tempFile">
                          <div class="file_img">
                            <div class="img">
                              <img :src="tempFile" alt="" width="80" />
                            </div>
                            <div class="file_info">
                              <p>{{ fileName }}</p>
                              <p class="file_size">{{ fileSize }}</p>
                            </div>
                          </div>
                          <div class="close_file_ic" @click="removeImage()">
                            <i class="lni lni-close"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadcrumbComponent from '@/components/shared/BreadcrumbComponent.vue';
import { mapGetters } from 'vuex';
import { io } from 'socket.io-client';
import dayjs from 'dayjs';
import { Howl } from 'howler';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

export default {
  name: 'ChatIndex',
  components: { BreadcrumbComponent },
  data() {
    return {
      socketUrl: process.env.VUE_APP_SOCKET_URL,
      socket: null,
      messages: [],
      tabIsActive: false,
      form: {
        message: '',
        customer_id: null,
        category_id: null,
        sub_category_id: null,
        link: '',
        type: '',
      },
      tempFile: '',
      fileSize: '',
      fileName: '',
      interval: '',
      incomingMessageSound: new Howl({
        src: ['/audio.mp3'],
        volume: 1.0,
      }),
      chats: [],
      selectedChat: null,
      imageSrc: null,
    };
  },
  computed: {
    ...mapGetters({
      customer: 'auth/getUserInfo',
    }),
    lastMessage() {
      if (this.messages?.length) {
        return this.messages.filter((item) => item.type === 'admin').pop();
      }
      return null;
    },
  },
  watch: {
    tabIsActive: {
      handler: function () {
        this.makeReadMessages();
      },
      deep: true,
    },
    selectedChat(newVal) {
      if (newVal) {
        this.getMessage();
      }
    },
  },
  mounted() {
    this.getChatList();
    this.checkTabStatus();
    this.interval = setInterval(this.updateTime, 60 * 1000);
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  methods: {
    getFileExtension(url){
      return url.split('.').pop().toLowerCase();
    },
    handlePaste(event) {
      const items = event.clipboardData.items;
      for (let item of items) {
        if (item.type.startsWith('image/')) {
          const file = item.getAsFile();

          if (file) {
            this.form.link = file; // Assign the file directly
            this.fileName = file.name; // Get the file name
            this.generateFileSize(file.size); // Generate the file size info
            this.tempFile = URL.createObjectURL(file); // Create a preview URL
          }
        }
      }
    },
    checkTabStatus() {
      this.tabIsActive = !document.hidden;
    },
    sendMessage(type) {
      if (this.form.message || this.form.link) {
        this.form.customer_id = this.customer.ticket_customer_id;
        this.form.type = type;

        let formData = new FormData();
        Object.entries(this.form).forEach(([key, file]) => {
          formData.append(key, file);
        });

        this.removeImage();
        this.form.message = '';
        this.axios
          .post('/chat/send-message', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(({ data }) => {
            if (data.success) {
              let index = this.messages.push({
                id: '',
                type: type,
                customer_id: this.customer.ticket_customer_id,
                created_at: 'Just Now',
                read: 0,
                message: data.data.data.message,
              });
              setTimeout(() => {
                this.scrollDown(true);
              }, 20);

              this.messages[index - 1].id = data.data.data.id;
              this.messages[index - 1].created_at = data.data.data.created_at;
              this.messages[index - 1].short_by_date =
                  data.data.data.short_by_date;
              this.messages[index - 1].link = data.data.data.link;
              this.messages[index - 1].api_token =
                  data.data.data.customer.api_token;
              this.socket.emit('customerMessage', data.data.data);
              setTimeout(() => {
                this.scrollDown(true);
                this.removeImage();
              }, 20);
            } else {
              this.showFailMsg(data?.error?.errors?.link[0]);
            }
          })
          .catch(() => {})
          .finally(() => {
            if (this.messages.length > 1) {
              this.showMainCategory = false;
              this.showSubCategory = false;
            }
          });
      }
    },
    joinChatSupport() {
      try {
        /*const response = this.axios.post('/join-chat-support', {
          session_id: uuidv4() // or other data you want to send
        });

        if (response.data.success) {
          // Handle success response
          auth.customer = response.data.data;
          // $toast.success(response.data.message);
        } else {
          // Handle failure response
          // $toast.error(response.data.message);
        }*/
      } catch (error) {
        console.log(error);
      }
    },
    initSocket() {
      if (this.customer && this.customer.api_token) {
        this.getMessage();
        this.socket = io(this.socketUrl + '/chat-support');

        // Join as a customer
        this.socket.emit('customerJoin', {
          customerId: this.customer.ticket_customer_id,
        });

        // Listen for messages from admin
        this.socket.on('customerMessage', (data) => {
          if (data.event_type === 'delete') {
            this.deleteEventMessage(data);
          } else if (data.event_type === 'read') {
            this.readStatusChange(data);
          } else if (data.type === 'admin') {
            this.playIncomingMessageSound();
            this.messages.push({ ...data });
            setTimeout(() => {
              this.scrollDown(true);
              this.makeReadMessages();
            }, 100);
          }
        });

        // Listen for messages from other customer tabs/devices
        this.socket.on('ownCustomerMessage', (data) => {
          if (!this.messages.some((msg) => msg.id === data.id)) {
            this.messages.push({ ...data });
            setTimeout(() => {
              this.scrollDown(true);
              this.makeReadMessages();
            }, 100);
          }
        });
      }
    },
    getMessage() {
      // let selectedSessionId;
      // if (!this.customer.session_id) {
      //   selectedSessionId = this.selectedChat?.session_id
      // }
      this.axios
        .get('/chat/get-message', {
          params: {
            customer_id: this.customer.id,
            chat_id: this.selectedChat?.id,
          },
        })
        .then(({ data }) => {
          this.messages = data.data.data;
          setTimeout(() => {
            this.updateTime();
            this.scrollDown();
            this.makeReadMessages();
          }, 50);
        });
    },
    getChatList() {
      this.axios
        .get('/chat/get-chat-list', {
          params: {
            customer_id: this.customer.id,
          },
        })
        .then(({ data }) => {
          this.chats = data.data.data;
          this.selectedChat = data?.data?.data[0];

          this.initSocket();
        });
    },
    updateTime() {
      if (this.messages && this.messages?.length) {
        const currentTime = dayjs();
        this.messages.map((item) => {
          const someDate = dayjs(item.short_by_date);
          item.created_at = someDate?.from(currentTime);
        });
      }
    },
    scrollDown(behavior = true) {
      const lastChildElement = this.$refs.scrollableDiv;
      let lastLi = lastChildElement.querySelector('li:last-child');
      if (behavior) {
        lastLi?.scrollIntoView({
          behavior: 'smooth',
        });
      } else {
        lastChildElement?.scrollIntoView();
      }
    },
    makeReadMessages() {
      if (this.customer && this.tabIsActive) {
        this.axios
          .get(
            '/chat/message-unread?customer_id=' +
              this.customer.id +
              '&type=admin'
          )
          .then((response) => {
            this.socket.emit('customerMessage', response.data);
          });
      }
    },
    removeMessage(i, message) {
      this.axios
        .get('/chat/delete-message?id=' + message.id + '&type=customer')
        .then((response) => {
          this.socket.emit('customerMessage', response.data);
          this.messages.splice(i, 1);
        });
    },
    deleteEventMessage(event) {
      let index = this.messages.findIndex(
        (item) => item.id === parseInt(event.id)
      );
      this.messages.splice(index, 1);
    },
    readStatusChange() {
      this.messages.map((item) => (item.read = 1));
    },
    removeImage() {
      this.tempFile = '';
      this.fileSize = '';
      this.fileName = '';
      this.form.link = '';
    },
    onFileChange(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      let file = event.target.files[0];
      this.form.link = file;
      this.fileName = file.name;
      this.generateFileSize(file.size);
      this.tempFile = URL.createObjectURL(file);
    },
    generateFileSize(size) {
      if (size / (1024 * 1024) >= 1) {
        this.fileSize = (size / (1024 * 1024)).toFixed(2) + ' MB';
      } else {
        this.fileSize = (size / 1024).toFixed(2) + ' KB';
      }
    },
    playIncomingMessageSound() {
      this.incomingMessageSound.play();
    },
    openFileModal() {
      this.$refs.fileInput.click();
    },
  },
};
</script>

<style scoped>
.file_upload {
  position: absolute;
  bottom: 30px;
}
.float-right {
  float: right;
}
.max-width-200 {
  max-width: 200px;
}
</style>
